

























import {Vue, Component, Prop} from 'vue-property-decorator';

@Component({
  name: 'InfoBlock',
})
export default class InfoBlock extends Vue {
  @Prop({type: String, default: ''}) public readonly title!: string;
  @Prop({type: String, default: ''}) public readonly text!: string;
  @Prop({type: String, default: ''}) public readonly textSecond!: string;
  @Prop({type: String, default: ''}) public readonly subtitle!: string;
  @Prop({type: String, default: ''}) public readonly phone!: string;
  @Prop({type: String, default: ''}) public readonly email!: string;
  @Prop({type: Boolean, default: false}) public readonly closePage!: boolean;
}
